import data from './cms/cms'
const commonModule = angular.module('common', [data]);

export default commonModule.name;



/** WEBPACK FOOTER **
 ** ./common/common.module.js
 **/